module.exports = __webpack_public_path__ + "static/media/grass-tile-2x.2b950a22.png";